function Head() {
    return (
        <header></header>
    );
  }
  
  export default Head;